export default __webpack_public_path__ + "static/media/1_dicaContexto.0cd68081.webp";